module.exports = __webpack_public_path__ + "static/media/cms.edba7b62.png";